import {Component, Input, OnInit} from '@angular/core';
import {MessagesService} from '../services/messages.service';
import {UIMessage} from './ui-message.model';
import {MatIconModule} from '@angular/material/icon';
import {AsyncPipe, NgClass, NgIf} from '@angular/common';

@Component({
    selector: "messages",
    templateUrl: "./messages.component.html",
    styleUrls: ["./messages.component.scss"],
    standalone: true,
    imports: [
        NgIf,
        NgClass,
        MatIconModule,
        AsyncPipe,
    ],
})
export class MessagesComponent implements OnInit {
  @Input() style: "normal" | "dialog" = "normal";

  constructor(public messages: MessagesService) {}

  ngOnInit() {}

  messageType(message: UIMessage) {
    return ["messages-" + message.type, this.style + "-messages"];
  }

  clearError() {
    this.messages.clear();
  }
  getMessageIcon(messageType: string) {
    switch (messageType) {
      case "error":
        return "cancel";
      case "warn":
        return "error";
      case "success":
        return "check_circle";
      case "info":
        return "info";
      default:
    }
  }
}
